var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Flex } from "..";
import Icon from "../Icon";
import { isEmpty } from 'lodash';
import React, { useCallback } from 'react';
import { InputHintError, Label, OptionalTag } from './Addons';
import { Container, CustomToggle, InputContainer, StyledLoader, ValidateIcon, } from './Input';
var checkInputValue = function (value, type) {
    if (typeof value === 'number')
        value = value.toString();
    return (!isEmpty(value ? value.toString() : undefined) ||
        (type === 'date' && !('ontouchstart' in document.documentElement)));
};
var StatelessInput = function (_a) {
    var className = _a.className, _b = _a.error, error = _b === void 0 ? '' : _b, hint = _a.hint, label = _a.label, loading = _a.loading, loadingDelay = _a.loadingDelay, onChange = _a.onChange, placeholder = _a.placeholder, type = _a.type, name = _a.name, validation = _a.validation, suffix = _a.suffix, optional = _a.optional, labelSuffix = _a.labelSuffix, _c = _a.value, value = _c === void 0 ? '' : _c, elementBelowInput = _a.elementBelowInput, props = __rest(_a, ["className", "error", "hint", "label", "loading", "loadingDelay", "onChange", "placeholder", "type", "name", "validation", "suffix", "optional", "labelSuffix", "value", "elementBelowInput"]);
    var hasValue = checkInputValue(value, type);
    var suffixVisibility = name === 'password' || !validation;
    var handleChange = useCallback(function (e) {
        onChange && onChange(e);
    }, [onChange]);
    return (React.createElement(Container, { "data-component": "StatelessInput" },
        React.createElement(Flex, { justifyContent: "space-between", alignItems: "flex-end", mb: "0.125rem", paddingX: "medium" },
            React.createElement(Label, null,
                label,
                optional && React.createElement(OptionalTag, null)),
            labelSuffix),
        React.createElement(InputContainer, { className: className, hasValue: hasValue },
            !loading && validation && (React.createElement(ValidateIcon, null, name !== 'password' && (!error ? React.createElement(Icon.ValidateSuccess, null) : null))),
            suffix && suffixVisibility && React.createElement(CustomToggle, { hasValue: hasValue }, suffix),
            loading && React.createElement(StyledLoader, { tiny: true, delay: loadingDelay }),
            React.createElement("input", __assign({ className: hasValue ? 'placeholder-shown' : '', placeholder: placeholder, type: type, name: name, onChange: handleChange, value: value }, props))),
        elementBelowInput,
        React.createElement(InputHintError, { error: error, hint: hint, validation: validation || false })));
};
export default StatelessInput;
//# sourceMappingURL=StatelessInput.js.map